import { useEffect, useRef, useState } from "react";
import type { Dispatch, SetStateAction } from "react";
import { apiRequest, getRolePreview } from "../../shared/api/client";
import { eligibleContractDocuments } from "./contract-editor-form";
import type { ContractEditorForm, Supplier, SupplierDocument } from "./contract-editor-form";
const previewSupplier = { id: "00000000-0000-4000-8000-000000000101", name: "Rota Esnek Film", status: "ACTIVE" };
const previewDocument = { id: "00000000-0000-4000-8000-000000000201", original_name: "İmzalı tedarik sözleşmesi.pdf", security_status: "CLEAN", verification_status: "VERIFIED" };

type Dependencies = {
  supplierId: string;
  seedSupplierId?: string;
  editorKey: string;
  setForm: Dispatch<SetStateAction<ContractEditorForm>>;
  setError: Dispatch<SetStateAction<string>>;
};
export function useContractEditorDataWorkspace({ supplierId, seedSupplierId, editorKey, setForm, setError }: Dependencies) {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [documents, setDocuments] = useState<SupplierDocument[]>([]);
  const preview = getRolePreview();
  const current = useRef({ supplierId, editorKey, preview });
  current.current = { supplierId, editorKey, preview };
  const documentOwner = useRef("");
  useEffect(() => {
    let active = true;
    if (preview) {
      setSuppliers([previewSupplier]);
      documentOwner.current = seedSupplierId ?? previewSupplier.id;
      setDocuments([previewDocument]);
      setForm(value => ({ ...value, supplierId: seedSupplierId ?? previewSupplier.id, signedDocumentId: previewDocument.id }));
      return;
    }
    setSuppliers([]);
    apiRequest<Supplier[]>("/api/suppliers", { cache: "no-store" })
      .then(items => { if (active) setSuppliers(items.filter(item => !item.status || item.status === "ACTIVE")); })
      .catch((caught: unknown) => { if (active) setError(caught instanceof Error ? caught.message : "Tedarikçiler yüklenemedi."); });
    return () => { active = false; };
  }, [seedSupplierId, editorKey, preview, setForm, setError]);
  useEffect(() => {
    if (preview) return;
    let active = true;
    documentOwner.current = supplierId;
    setDocuments([]);
    setForm(value => ({ ...value, signedDocumentId: "" }));
    if (!supplierId) return;
    const isCurrent = () => active && current.current.supplierId === supplierId && current.current.editorKey === editorKey && current.current.preview === preview;
    apiRequest<SupplierDocument[]>(`/api/suppliers/${supplierId}/documents`, { cache: "no-store" })
      .then(items => { if (isCurrent()) setDocuments(eligibleContractDocuments(items, new Date())); })
      .catch((caught: unknown) => { if (isCurrent()) setError(caught instanceof Error ? caught.message : "İmzalı belgeler yüklenemedi."); });
    return () => { active = false; };
  }, [supplierId, editorKey, preview, setForm, setError]);
  return { suppliers, documents: documentOwner.current === supplierId ? documents : [] };
}
